import MobileDeveloperPage from "./MobileDeveloperPage";

export default function SwiftDeveloperPage() {
  return <MobileDeveloperPage technology="swift" />;
}
